/* global $, ShopgateProductDetailsCore */

$.shopgate = $.shopgate || {};

/**
 * This is a ShopgateProductDetailsCore sort plugin
 * @param  {Object} _core Reference to the ShopgateProductDetailsCore
 * @return {Object} An object with informations about the capabilities of this plugin
 */
var defaultSortPlugin = function (_core, _coreOptions) {

  /**
   * This function cares about sorting product attribute values
   * @param  {String} productAttributeName The name of the attribute whos values should be sorted
   * @param  {Array} productAttributeValues A list of the available product attribute values
   * @param  {Object} shopProperties Contains properties of the current shop {shopNumber, shopGroup}
   * @return {Array} The sorted product attribute value list
   */
  function _onProductAttributeSort(productAttributeName, productAttributeValues, shopProperties) {
    var sort = typeof $.sgHelpers.sizeSort == 'function' ? $.sgHelpers.sizeSort : null;
    return productAttributeValues.sort(sort);
  }

  const hooks = {
    vendor: 'Shopgate',
    name: 'Default sort plugin',
    product_attribute_names: [
      'size',
      'sizes',
      'größe',
      'grösse',
      'groesse',
      'größen',
      'grössen',
      'größenauswahl',
      'groessen',
      'rozmiar',
      'taille',
      'tailles',
      'select your size',
      'shirt size',
    ],
    shop_groups: [],
    shop_numbers: [],
    type: ['sort.attributes'],
    onProductAttributeSort: _onProductAttributeSort,
  };

  return hooks;
};

if (typeof ShopgateProductDetailsCore == 'object' && typeof ShopgateProductDetailsCore.registerPlugin == 'function') {
  ShopgateProductDetailsCore.registerPlugin(defaultSortPlugin);
} else {
  console.warn('No instance of "ShopgateProductDetailsCore" found');
}


// WEBPACK FOOTER //
// ./Library/1.0/common/product_details/sort/jquery.shopgate-product-details-sort-default.js